import { useDefaultTable } from './useDefaultTable';
import { useSelectedTable } from './useSelectedTable';

export const useTable = () => {
    const defaultTable = useDefaultTable();
    const selectedTable = useSelectedTable();

    return selectedTable ?? defaultTable;
};
